import React from 'react';

const JobDetailsCard = ({ jobDetails }) => {
    const DetailItem = ({ label, value }) => (
        <div className="detail-item">
            <span className="detail-label">{label}:</span>
            <span className="detail-value">{value || 'Not specified'}</span>
        </div>
    );

    return (
        <div className="job-details-card">
            <h3 className="section-title">Job Requirements Details</h3>
            <div className="job-details-grid">
                <DetailItem label="Job Requirement ID" value={jobDetails?.jobReqId} />
                <DetailItem label="Job Title" value={jobDetails?.jobTitle} />
                <DetailItem label="Company Name" value={jobDetails?.companyName} />
                <DetailItem label="Job Location" value={jobDetails?.jobLocation} />
                <DetailItem label="Skill-set" value={jobDetails?.skillSet} />
                <DetailItem label="Qualification" value={jobDetails?.qualification} />
                <DetailItem label="Passed-out Year" value={jobDetails?.passedOutYear} />
                <DetailItem label="Experience Required" value={jobDetails?.experienceRequired} />
                <DetailItem label="Interview Date" value={jobDetails?.interviewDate} />
                <DetailItem label="Interview Type" value={jobDetails?.interviewType} />
                <DetailItem label="Number of Openings" value={jobDetails?.numberOfOpenings} />
                <DetailItem label="Allowed Branches" value={jobDetails?.allowedBranches} />

                <div className="detail-item full-width">
                    <span className="detail-label">Job Description:</span>
                    <span className="detail-value">{jobDetails?.jobDescription || 'Not specified'}</span>
                </div>
            </div>
        </div>
    );
};

export default JobDetailsCard;